export enum ClientName {
    EUREKA = 'eureka',
    ANALYTICS = 'analytics',
}

export const ClientService = Symbol.for('ClientService');

export interface ClientService {
    /**
     * 客户端名称
     * 用于标识不同的客户端类型
     */
    readonly clientName: ClientName;
    /**
     * 是否为Eureka
     * 用于区分不同产品线
     */
    readonly isEureka: boolean;
}
